var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},_vm._l((_vm.categories),function(category){return _c('div',{key:category.id,staticClass:"block"},[_c('div',{staticClass:"block-header block-header-default"},[_c('h3',{staticClass:"block-title"},[_vm._v(_vm._s(category.name))])]),_vm._v(" "),_c('div',{staticClass:"block-content"},[_c('bs-table',{attrs:{"presetColumn":"price","columns":[
              {
                name: 'Naam',
                key: 'name',
                class: 'font-w700',
                sort: true,
              },
              {
                name: 'Aantal',
                key: 'sites_count',
                sort: true,
                tooltip: 'Dit betreft het aantal startpagina\'s in het desbetreffende linkpakket.',
              },
              {
                name: 'IP',
                key: 'total_ip',
                sort: true,
                tooltip: ' Dit betreft het totaal aantal verschillende IP backlinks naar alle startpaginalinks in het desbetreffende linkpakket.',
              },
              {
                name: 'PA',
                key: 'average_pa',
                sort: true,
                tooltip: 'Dit betreft de gemiddelde PA waarde van alle startpaginalinks in het desbetreffende linkpakket.',
              },
              {
                name: 'DA',
                key: 'average_da',
                sort: true,
                tooltip: 'Dit betreft de gemiddelde DA waarde van alle startpaginalinks in het desbetreffende linkpakket.',
              },
              {
                name: 'TF',
                key: 'average_tf',
                sort: true,
                tooltip: 'Dit betreft de gemiddelde TF waarde van alle startpaginalinks in het desbetreffende linkpakket.',
              },
              {
                name: 'CF',
                key: 'average_cf',
                sort: true,
                tooltip: 'Dit betreft de gemiddelde CF waarde van alle startpaginalinks in het desbetreffende linkpakket.',
              },
              {
                name: 'Totaal',
                key: 'sites_price',
                sort: true,
                tooltip: 'Indien u gebruikerskorting heeft, wordt deze in de winkelwagen berekend',
              },
              {
                name: 'Pakketprijs',
                key: 'price',
                sort: true,
              },
              {
                name: 'Acties',
                key: 'id',
                class: 'text-center',
              },
            ],"data":category.packages},scopedSlots:_vm._u([{key:"Naam",fn:function({ props }){return [_c('a',{staticClass:"link-fx",attrs:{"href":_vm.$route('packages.show', props.id)}},[_vm._v(_vm._s(props.name))])]}},{key:"Aantal",fn:function({ props }){return [_vm._v("\n              "+_vm._s(props.sites.length)+"\n            ")]}},{key:"IP",fn:function({ props }){return [_vm._v("\n              "+_vm._s(_vm._f("sumByStat")(props.sites,'site.stat.ip'))+"\n            ")]}},{key:"PA",fn:function({ props }){return [_vm._v("\n              "+_vm._s(_vm._f("sumByStat")(props.sites,'site.stat.pa', props.sites.length))+"\n            ")]}},{key:"DA",fn:function({ props }){return [_vm._v("\n              "+_vm._s(_vm._f("sumByStat")(props.sites,'site.stat.da', props.sites.length))+"\n            ")]}},{key:"TF",fn:function({ props }){return [_vm._v("\n              "+_vm._s(_vm._f("sumByStat")(props.sites,'site.stat.tf', props.sites.length))+"\n            ")]}},{key:"CF",fn:function({ props }){return [_vm._v("\n              "+_vm._s(_vm._f("sumByStat")(props.sites,'site.stat.cf', props.sites.length))+"\n            ")]}},{key:"Totaal",fn:function({ props }){return [_c('del',[_vm._v(_vm._s(_vm._f("currency")(_vm.$_.sumBy(props.sites, 'price'))))])]}},{key:"Pakketprijs",fn:function({ props }){return [_vm._v("\n              "+_vm._s(_vm._f("currency")(props.price))+"\n            ")]}},{key:"Acties",fn:function({ props }){return [_c('a',{staticClass:"btn btn-sm btn-success",attrs:{"href":_vm.$route('packages.show', props.id),"data-toggle":"tooltip","data-placement":"top","data-original-title":"Pakket bekijken"}},[_c('i',{staticClass:"fa fa-eye"}),_vm._v(" Bekijken\n              ")])]}}],null,true)})],1)])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }